<template>
  <div class="c-content__imageBlockBottom c-standard">
    <div class="c-content__imageBlockBottom--text">

      <h3 class='title_h3 relative'>
        <span>{{ content.title1 }}</span>
        <span>{{ content.title2 }}</span>
        <div class="textBgLeft absolute"></div>
      </h3>
      <p>{{ content.text }}</p>

    </div>
    <div class="c-content__imageBlockBottom--image">
      <img :src="content.img" :alt="content.title">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'imageBlockBottom',
    data(){
      return{
        content:{
          title1: this.$t('homepage.imageBlock.title1'),
          title2: this.$t('homepage.imageBlock.title2'),
          img: require('../../assets/img/pic_icare.jpg'),
          text: this.$t('homepage.imageBlock.content')
        }
      }
    },
    computed: {

    },
    methods:{

    },
    created(){

    }
  }
</script>

<style>


</style>
